const HAS_PERSISTENT_LOGGING  = false

const ENABLED_LOGGING = false; // (process.env.NODE_ENV === "development" ?? false) || HAS_PERSISTENT_LOGGING
class Logger {
    constructor(verbose) {
        this.verbose = verbose

        if ("EVERSIGN_CONFIG" in window) {
            this.verbose = window.EVERSIGN_CONFIG?.verbose ?? ENABLED_LOGGING;
        }
        console.log("[LOGGER]", "init verbose", this.verbose);
        if(HAS_PERSISTENT_LOGGING){
            console.log("[LOGGER]", "HAS_PERSISTENT_LOGGING");
        }
    }

    toggle(){
        this.verbose = !this.verbose
        console.log("[LOGGER]", this.verbose)
    }

    log(message, ...optionalParams) {
        if (this.verbose) {
            console.log("[LOGGER]", message, ...optionalParams);
        }
    }
    trace(message, ...optionalParams) {
        if (this.verbose) {
            console.groupCollapsed(`[LOGGER] Trace ${message}`, window.location.pathname);
            console.trace("[LOGGER]", message, ...optionalParams);
            console.groupEnd();
        }
    }
    error(message, ...optionalParams) {
        if (this.verbose) {
            console.error("[LOGGER]", message, ...optionalParams);
        }
    }
    warn(message, ...optionalParams) {
        if (this.verbose) {
            console.warn("[LOGGER]", message, ...optionalParams);
        }
    }
}


//
// When logger is used in utilities but utils are used in several main  
//
export const logger = window.evrLogger ?? new Logger(ENABLED_LOGGING);
if(!window.evrLogger){
    window.evrLogger = logger
}

export default logger;
